export const tableColumns = [{ label: "Name" }, { label: "Group" }];
